import { AxiosRequestConfig } from "axios";
import { AXIOS_INSTANCE, BASE_URL } from "../App";

export async function GetStateMap(clientId:string,salesOrg: string) {
  const config: AxiosRequestConfig = {
    method: "GET",
    params: {
      clientId,
      salesOrg,
    },
    url: `${BASE_URL}/api/maps/state`,
  };

  return await AXIOS_INSTANCE(config);
}

export async function GetCountyMap(clientId:string,salesOrg: string) {
  const config: AxiosRequestConfig = {
    method: "GET",
    params: {
      clientId,
      salesOrg,
    },
    url: `${BASE_URL}/api/maps/county`,
  };

  return await AXIOS_INSTANCE(config);
}

//fetch warehouse
export async function getWarehouseLocation(salesOrg: any, plant:string) {
  const config: AxiosRequestConfig = {
    method: "GET",
    params: {
      clientId: "100",
      salesOrg,
      plant
    },
    url: `${BASE_URL}/api/maps/getWarehouselocation`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}

export async function GetCensusData(clientId:string,salesOrg: string) {
  const config: AxiosRequestConfig = {
    method: "GET",
    params: {
      clientId,
      salesOrg,
    },
    url: `${BASE_URL}/api/maps/census`,
  };
  return await AXIOS_INSTANCE(config);
}


// export async function GetVendingLocations(clientId:string,salesOrg: string) {
//   const config: AxiosRequestConfig = {
//     method: "GET",
//     params: {
//       clientId,
//       salesOrg,
//     },
//     url: `${BASE_URL}/api/maps/vending/locations`,
//   };
//   return await AXIOS_INSTANCE(config);
// }

export async function GetClusterLocations(clientId:string,salesOrg: string) {
  const config: AxiosRequestConfig = {
    method: "GET",
    params: {
      clientId,
      salesOrg,
    },
    url: `${BASE_URL}/api/maps/cluster/locations`,
  };
  return await AXIOS_INSTANCE(config);
}

export async function GetClusterDetails(clientId:string,salesOrg: string, clusterId:string) {
  const config: AxiosRequestConfig = {
    method: "GET",
    params: {
      clientId,
      salesOrg,
      clusterId,
    },
    url: `${BASE_URL}/api/maps/cluster/details`,
  };
  return await AXIOS_INSTANCE(config);
}